import script from "./FlyerImageCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyerImageCarousel.vue?vue&type=script&setup=true&lang=js"

import "./FlyerImageCarousel.vue?vue&type=style&index=0&id=254e9101&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-254e9101"]])

export default __exports__